import { ApprovalsService } from 'api-clients/monolith';

/**
 * Derived from the generated client rather than hand-written.
 *
 * The rule tree is wide (levels → approvers → backup approvers) and every field
 * on it is optional in the OpenAPI document, so a hand-maintained mirror would
 * disagree with the server the first time a field is added and nothing would
 * fail to compile. Deriving means a contract change lands as a type error here.
 */
type RulesResponse = Awaited<
  ReturnType<typeof ApprovalsService.getInternalApiApprovalsRules>
>;

export type ApprovalRule = NonNullable<RulesResponse['rules']>[number];
export type ApprovalRuleLevel = NonNullable<ApprovalRule['levels']>[number];
export type ApprovalRuleApprover = NonNullable<
  ApprovalRuleLevel['approvers']
>[number];

/**
 * The editor's Offers | Openings toggle. One entity-agnostic rule table backs
 * both, so this is a filter over one list rather than two features.
 */
export type SubjectType = NonNullable<ApprovalRule['subject_type']>;

export const OFFER: SubjectType = 'OfferLetter';
export const OPENING: SubjectType = 'Funnel';

/**
 * One user an approver roster may offer, with the subject types they may
 * approve, as `getInternalApiApprovalsApproverOptions` returns them.
 *
 * Lives here rather than beside the panel that fetches it so the level card's
 * children can take it without importing from their own parent — and derived,
 * not hand-written, because that is the rule this file opens by stating.
 */
export type UserOption = Awaited<
  ReturnType<typeof ApprovalsService.getInternalApiApprovalsApproverOptions>
>['approvers'][number];
